var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchForwardChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 22,
  fill: "none",
  viewBox: "0 0 21 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M19.8 11a9.3 9.3 0 1 1-18.6 0 9.3 9.3 0 0 1 18.6 0m1.2 0c0 5.799-4.701 10.5-10.5 10.5S0 16.799 0 11 4.701.5 10.5.5 21 5.201 21 11m-9.088-4.196a.6.6 0 1 0-.865.832L13.71 10.4h-8.67a.6.6 0 0 0 0 1.2h8.67l-2.662 2.764a.6.6 0 1 0 .865.832l3.64-3.78a.6.6 0 0 0 0-.832z",
  clipRule: "evenodd"
})));
export { SvgSearchForwardChevron as ReactComponent };